import { RequestHelper } from "../Helpers/RequestHelper.js";
import { DataDriver } from "../Drivers/DataDriver.js";
// import { AllCarUsaApi } from "../API/AllCarUsaApi";

export class LenderDeskDriver extends DataDriver {
    constructor(pmdrs) {
        super(pmdrs);
        this.key = DataDriver.LENDERDESK_KEY;
        this.themeClass = "allcarusa-theme";
        this.rebates = { finance: {}, lease: {} };//key by programId
        // this.allCarUsaApi = new AllCarUsaApi({
        //     production: this.pmdrs.config.production,
        // });
    }

    pullApiConfig(successCallback, errorCallback) {
        // successCallback();
        // return;
        let driver = this;
        let pmdrs = this.pmdrs;
        let vin = pmdrs.frontApp.config.vehicle.vin;
        //SUCCESS
        let sc = (response) => {
            var vinList = JSON.parse(response);
            var initialPayments = vinList[vin];
            if(!initialPayments) {
                console.info("No payments available for: " + vin);
                return;//skip if not enabled
            }
            driver.initialPayments = initialPayments;
            console.log(initialPayments);

            if (successCallback) {
                successCallback();
            }
        };

        //ERROR
        let ec = () => {
            console.error("Error getting LenderDesk config");
            if (errorCallback) {
                errorCallback();
            }
        };

        //get APR from pm-drs-api
        pmdrs.pmApi.getLenderDeskVinListPayments(
            pmdrs.config.accountId,
            {vins: [vin]},            
            sc,
            ec
        );
    }

    getInitialPayment(type, successCallback, errorCallback){
        var payment = this.initialPayments[type];        
        if(!payment){//IF NO PAYMENTS
            successCallback(null);
            return;
        }
        let paymentObject = this.formatApiPayment(payment);
        successCallback(paymentObject);
    }

    offerTypeToPmType(lenderDeskOfferType) {
        lenderDeskOfferType = lenderDeskOfferType.toLowerCase();
        return lenderDeskOfferType === "loan" ? "finance" : lenderDeskOfferType;
    }

    getDefaultCreditRatingLabel(dealType){
        return "";
    }

    getCashPriceLabel(){
        return 'Net Price';
    }

    precachePayments(paymentData, type, accessoriesPrices){
        let requestParams = this.getRequestParams(paymentData, type);
        requestParams.accessoriesPrices = accessoriesPrices;//precache param
        
        this.pmdrs.pmApi.getPrecacheCustomQuotes(requestParams);    
        return;
    }
    
    getRequestParams(paymentData, type){
        let pmdrs = this.pmdrs;
        let vehicle = pmdrs.frontApp.config.vehicle;
        // Resolved against paymentData.conditionalOffers (keyed by programId, already present —
        // see formatApiPayment() below) instead of trusting a pre-summed total from the
        // frontend — the backend needs SelectedRebateIds to do its own sum server-side too,
        // so this has to stay in sync with the exact same ids sent below.
        let selectedRebateIds = paymentData.selectedRebateIds || [];
        let conditionalOffers = paymentData.conditionalOffers || {};
        let selectedConditionalTotal = selectedRebateIds.reduce((total, programId) => {
            let offer = conditionalOffers[programId];
            return total + (offer ? offer.amount : 0);
        }, 0);

        let selliingPrice = parseFloat(vehicle.finalPrice) + paymentData.accessoriesPrice;//add accessories
        selliingPrice = selliingPrice - selectedConditionalTotal;//sub selected conditional offers

        // FormatHelper.serialize() (used by every RequestHelper.ajax GET call) silently drops
        // empty arrays from the query string entirely — so a real, empty selection (user
        // unchecked every conditional offer) would arrive at the backend indistinguishable from
        // "param omitted" (old widget build), and PmRatesController would wrongly apply every
        // conditional item instead of none. Pad with a placeholder no real programId can ever
        // match, purely so the array survives serialization as "present but nothing selected" —
        // does not touch the shared serializer, which other callers (e.g. Lenders below) rely on
        // dropping real empty arrays.
        let selectedRebateIdsForRequest = selectedRebateIds.length ? selectedRebateIds : ["__none_selected__"];

        const isLease = type == "lease";
        const isFinance = type == "finance";
        const isCash = type == "cash";
        // var lenders = ['US-130', 'US-169'];        
        var lenders = [];
        if(paymentData.lenderId){
            lenders = [paymentData.lenderId]
        }
        let requestParams = {
            'Vin': vehicle.vin,
            'Type': vehicle.condition,//new | used | certified | virtual
            'ZipCode': paymentData.customerZipCode || pmdrs.config.dealerZipCode,
            'OfferType': isFinance ? "Loan" : type, //blank to get all, Lease, Loan or Cash
            'Miles': vehicle.mileage,//odometer            
            // 'SellingPrice': selliingPrice,//SellingPrice is the api/payments endpoint
            'PurchasePrice': selliingPrice,
            // 'MSRP': pmdrs.frontApp.getVehicleRetailPrice(),//not sending MSRP because it overrides what they use as base price from the export
            'AnnualMileage': paymentData.mileageAllowance, //Number of miles which must not be exceeded during the course of the lease agreement.             
            // US-130 is Chrysler Capital, asked to Brad
            // US-169 is Stellantis Financial Services, asked to Brad. 
            // They both provide incentives in rebates or conditionalRebates, we're trying to use them  
            'Lenders': lenders,//List of IDs of lenders to be used. Only payments related to this lenders will be retrieved. To know the possible values for the lender IDs, check the Lenders GET operation. Cash blank to get payments related to any lender.
            'IncludeCustomDisclosures': "true",//default is false,
            "Beacon": paymentData.creditRating,//required for all types
            "DownPayment": 0,//required for all types, overridden below for finance/lease
            // Internal-only signal, stripped by LenderDeskController before forwarding to the
            // real external vendor (see signal-based-rebate-selection-plan.md) — kept here so
            // it can be logged/audited and so the PmRates branch below can reuse it.
            "SelectedRebateIds": selectedRebateIdsForRequest,
        };

        if (!isCash) {
            // let downPayment = parseFloat(paymentData.cashDown) + parseFloat(paymentData.tradeInData.tradeInEstimate);
            let downPayment = parseFloat(paymentData.cashDown);//trying without tradeInEstimate

            requestParams["Term"] = paymentData.loanMonths;
            requestParams["DownPayment"] = downPayment;
        }

        requestParams["TradeIn"] = paymentData.tradeInData.tradeInEstimate;
        return requestParams;
    }

    /**
     * [getMonthlyPayment description]
     * @param  {Boolean} taxes to get taxes or not
     * @param  {string} type            lease of finance
     * @param  {object} paymentData     check format in PaymentSection getPaymentParams return paymentData;
     * @param  {function} successCallback
     * @param  {function} errorCallback
     * @return void
     */
    getPayment(taxes, type, paymentData, successCallback, errorCallback) {
        let pmdrs = this.pmdrs;
        let requestParams = this.getRequestParams(paymentData, type);

        let sc = (response) => {
            const payments = JSON.parse(response).payments;
            //PmRates responses bundle multiple offer types (e.g. Loan+Cash) in one payload;
            //AllCarUsa responses are already filtered server-side to a single OfferType, so
            //this still resolves to the same entry as payments[0] did for that path.
            var payment = payments.find((p) => this.offerTypeToPmType(p.offerType) === type) || payments[0];
            if(!payment){//IF NO PAYMENTS
                successCallback(null);
                return;
            }
            // // LENDER FILTER
            // if(paymentData.lenderId){
            //     var found = false;
            //     for (const p of payments) {
            //         if(p.lenderId == paymentData.lenderId){
            //             payment = p;
            //             found=true;
            //             break;
            //         }
            //     }
            //     if(!found){
            //         successCallback(null);
            //         return;
            //     }
            // }


            let paymentObject = this.formatApiPayment(payment);

            successCallback(paymentObject);
        };

        if (this.initialPayments[type]?.pmRates) {
            let vehicle = pmdrs.frontApp.config.vehicle;
            let pmRatesParams = {
                Year: vehicle.year,
                SellingPrice: requestParams.PurchasePrice,
                DownPayment: requestParams.DownPayment,
                Vin: vehicle.vin,
                //doc fee doesn't change per recalculation — carry it over from the initial quote
                //so the response keeps surfacing it (SellingPrice above already has it baked in)
                DocFee: this.initialPayments[type]?.docFee || 0,
                //PmRates tiers can be condition-gated (e.g. southbay: used vs new APR/term) —
                //without this, dealers with per-condition tiers match nothing and silently fall
                //back to a Cash-only response during recalculation
                Condition: vehicle.condition,
                //nullable — PmRatesController applies every conditional item when omitted,
                //matching a widget build that hasn't shipped this signal yet
                SelectedRebateIds: requestParams.SelectedRebateIds,
            };
            //requestParams.Term is only set for lease/finance (see getRequestParams above) — mirror
            //that here instead of always assigning it, otherwise cash recalculation would serialize
            //a literal "Term=undefined" query param
            if (requestParams.Term !== undefined) {
                pmRatesParams.Term = requestParams.Term;
            }
            pmdrs.pmApi.getPmRatesCustomQuotes(pmRatesParams, sc, errorCallback);
            return;
        }

        if(taxes){
            pmdrs.pmApi.getAllCarUsaCustomQuotesWithTaxes(requestParams, sc, errorCallback);
        }else{
            pmdrs.pmApi.getAllCarUsaCustomQuotes(requestParams, sc, errorCallback);
        }
        // pmdrs.pmApi.getAllCarUsaPayments(requestParams, sc, errorCallback);
    }

    //maps to pm-drs format standard, check example in PixelmotionDriver.js
    formatApiPayment(apiPayment){
        let disclaimerText = apiPayment.disclosureText || null;//default use the generic one
        if(apiPayment.disclosures && apiPayment.disclosures[0]){
            disclaimerText = apiPayment.disclosures[0].content;
        }
        if(disclaimerText){
            disclaimerText = disclaimerText.replaceAll("{{pmDealerName}}", this.pmdrs.config.dealerName);
        }
        let rebatesAmount = 0;
        apiPayment.rebates?.forEach(rebate => {         
            rebatesAmount += rebate.amount;
        });
        let dealType = this.offerTypeToPmType(apiPayment.offerType);
        let paymentObject = this.formatPaymentObject({
            dealType: dealType,
            moneyFactor: dealType === 'lease'
                ? apiPayment.interestRate.toFixed(2)         // lease: interestRate is already a percentage (e.g. 2.4 = 2.4%)
                : (apiPayment.originalRate * 100).toFixed(2), // finance: originalRate is a decimal fraction (e.g. 0.059 = 5.9%)
            monthlyPayment: apiPayment.payment,
            totalPayments: apiPayment.totalPayments,
            downPayment: apiPayment.downPayment,
            term: apiPayment.term,
            expirationDate: apiPayment.expirationDate,
            disclaimerText: disclaimerText,
            conditionalOffers: this._formatCRebates(apiPayment),//PMDRS will call it conditionalOffers
            incentives: this._formatRebates(apiPayment),//PMDRS will call it incentives
            incentivesTotal: this._getRebatesTotal(apiPayment),//PMDRS will call it incentives
            lenderId: apiPayment.lenderId,
            lenderName: apiPayment.lender || null,
            creditRating: apiPayment.beacon,
            purchasePrice: apiPayment.purchasePrice,
            payment: apiPayment.payment,
            financedAmount: apiPayment.purchasePrice - apiPayment.downPayment - rebatesAmount,
            priceStack: apiPayment.priceStack,
            docFeeForTotal: apiPayment.docFeeForTotal,
            docFeeDisplay: apiPayment.docFeeDisplay,
            cashDownDisplay: apiPayment.cashDownDisplay,
            netPriceDisplay: apiPayment.netPriceDisplay,
            finalPriceDisplay: apiPayment.finalPriceDisplay,
            isValid: apiPayment.isValid,
            dueAtSignBase: apiPayment.dueAtSignBase,
            dueAtSignWithTaxes: apiPayment.dueAtSignWithTaxes,
            residualValue: apiPayment.residualValue,
            residualPercentage: apiPayment.residualPercentage * 100,
        });

        if(apiPayment.feesAndTaxes){
            paymentObject.feesAndTaxesTotal = apiPayment.feesAndTaxes.feeTotal;
            paymentObject.feesAndTaxesList = this._formatFeesAndTaxesList(apiPayment.feesAndTaxes);
            const feeDetails = apiPayment.feesAndTaxes.feeDetails || [];
            paymentObject.leaseTaxesTotal = feeDetails
                .filter(fee => fee.feeType === 'Sales')
                .reduce((sum, fee) => sum + fee.amount, 0);
            paymentObject.leaseGovFeesTotal = feeDetails
                .filter(fee => fee.feeType === 'Registration')
                .reduce((sum, fee) => sum + fee.amount, 0);
        }

        paymentObject.docFee = apiPayment.docFee || 0;
        paymentObject.dueAtSign = apiPayment.dueAtSign || 0;
        //lease terms for the tabs widget's payment disclaimer; null when the API doesn't say
        paymentObject.mileageLimit = apiPayment.mileageLimit ?? null;
        paymentObject.perMileCharge = apiPayment.perMileCharge ?? null;
        paymentObject.securityDeposit = apiPayment.securityDeposit ?? null;
        paymentObject.paymentBeforeTaxes = apiPayment.paymentBeforeTaxes || null;

        return paymentObject;
    }

    /**
     * Function to format their taxes into our display format
     * @param {object} feesAndTaxes, format coming from api
     */
    _formatFeesAndTaxesList(feesAndTaxes){
        var list = [];
        (feesAndTaxes.feeDetails || []).forEach(fee => {
            list.push({
                label: fee.feeName + (fee.feeTaxRate ? ` (${fee.feeTaxRate}%)` : ""),
                amount: fee.amount,
            });
        });
        return list;
    }

    //payments object from allcarusa api call
    _formatCRebates(apiPayment){
        if(!apiPayment) return {};
        var cRebates = {};
        (apiPayment.conditionalRebates || []).forEach(cRebate => {
            if(cRebate.programDescription.includes("TDM")) return;//skip TDMs
            cRebates[cRebate.programId] = cRebate;
        })
        return cRebates;
    }

    //payments object from allcarusa api call
    _formatRebates(apiPayment){
        if(!apiPayment) return {};
        var rebates = {};
        (apiPayment.rebates || []).forEach(rebate => {
            // if(rebate.programDescription.includes("TDM")) return;//skip TDMs
            rebates[rebate.programId] = rebate;
        })
        return rebates;
    }

    //payments object from allcarusa api call
    _getRebatesTotal(apiPayment){
        if(!apiPayment) return {};
        var rebates = this._formatRebates(apiPayment);
        var total = 0;
        for (const programId in rebates) {
            var offer = rebates[programId];
            total += offer.amount;
        }
        return total;
    }

    /**
     * [getCreditRanges description]
     * @param  {[type]} dealType lease or finance
     * @return {[type]}          [description]
     */
    getCreditRanges(dealType) {
        return [
            {label: "Platinum Credit", min: '770', max: '850'},
            {label: "A+ Credit", min: '720', max: '769'},
            {label: "A Credit", min: '680', max: '719'},
            {label: "B Credit", min: '650', max: '679'}
        ];//this.apr.range_config[dealType];
    }

    getTermsOptions(dealType, creditRatingLabel, mpy){
        var payment = this.initialPayments[dealType];        
        if(payment && payment.termsOptions) return payment.termsOptions.sort((a, b) => a - b);
        switch (dealType) {
            case "lease":
                return [36,39,42,48];

            case "finance":
                return [36, 48, 60, 72];//72
        }
        return [];
    }

    getMillesPerYearOptionsForLease() {
        return [10000, 12000, 15000];//5000, 7500 removed to avoid empty responses
    }

    getTaxesBtnText(){
        return "Add Fees & Taxes";
    }
}
